import type { AmountSeparators } from "./format-amount-string";

/**
 * Число с дробной частью и разрядами - по нему Intl отдает оба разделителя.
 */
const SAMPLE_AMOUNT = 1234567.5;

/** ru-RU: неразрывный пробел и запятая */
const FALLBACK_SEPARATORS: AmountSeparators = {
  decimal: ",",
  group: "\u00a0",
};

/**
 * Разделители дроби и разрядов для локали.
 * Берем у Intl: ru-RU и ky-KG дают неразрывный пробел и запятую,
 * en-US - запятую и точку.
 */
export const getAmountSeparators = (locale: string): AmountSeparators => {
  const parts = new Intl.NumberFormat(locale).formatToParts(SAMPLE_AMOUNT);
  const separatorOf = (type: "decimal" | "group"): string =>
    parts.find((part) => part.type === type)?.value ??
    FALLBACK_SEPARATORS[type];

  return {
    decimal: separatorOf("decimal"),
    group: separatorOf("group"),
  };
};
